'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var NOTHING = 'NOTHING';
var SET_HIDDEN = 'SET_HIDDEN';
var SET_READONLY = 'SET_READONLY';

var ALL = [{
  id: NOTHING,
  text: 'Отображается'
}, {
  id: SET_HIDDEN,
  text: 'Скрыто'
}, {
  id: SET_READONLY,
  text: 'Только для чтения'
}];

exports.NOTHING = NOTHING;
exports.SET_HIDDEN = SET_HIDDEN;
exports.SET_READONLY = SET_READONLY;
exports.ALL = ALL;


//////////////////
// WEBPACK FOOTER
// ./~/form-service/frontend/lib/constants/fieldActions.js
// module id = 773
// module chunks = 5